// extracted by mini-css-extract-plugin
export var contain = "splash-module--contain--2pI75";
export var heading = "splash-module--heading--DTE3U";
export var subhead = "splash-module--subhead--1fl9W";